module.exports = __webpack_public_path__ + "static/media/logo18.333f0007.png";